import React, { useEffect, useState } from "react";
import { Trophy } from "@phosphor-icons/react";
import api, { fileUrl } from "../lib/api";
import { frameStyle } from "../lib/badgeFrames";

const RANK_STYLES = [
  "bg-jam-gold/25 border-jam-gold/50 text-jam-gold",
  "bg-slate-300/15 border-slate-300/40 text-slate-200",
  "bg-orange-400/15 border-orange-400/40 text-orange-300",
];
const MEDALS = ["🥇", "🥈", "🥉"];

/**
 * GiftLeaderboardBanner — live top-gifters banner shown during streams.
 * Polls /api/live/{sessionId}/gift-leaderboard every 10s; hides when nobody
 * has gifted yet.
 */
export default function GiftLeaderboardBanner({ sessionId }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!sessionId) return;
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get(`/live/${sessionId}/gift-leaderboard`, { params: { limit: 3 } });
        if (alive) setRows(data || []);
      } catch (e) { /* silent */ }
    };
    load();
    const t = setInterval(load, 10_000);
    return () => { alive = false; clearInterval(t); };
  }, [sessionId]);

  if (rows.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 overflow-x-auto" data-testid="gift-leaderboard-banner">
      <span className="flex items-center gap-1 text-jam-gold text-[9px] tracking-[0.3em] uppercase font-black flex-shrink-0">
        <Trophy size={12} weight="fill" /> Top Gifters
      </span>
      {rows.map((r, i) => {
        const fs = frameStyle(r.sender_badge_frame);
        return (
        <div
          key={r.sender_id}
          className={`flex items-center gap-1.5 rounded-full border px-2 py-1 flex-shrink-0 backdrop-blur-md ${RANK_STYLES[i] || RANK_STYLES[2]} ${fs ? `${fs.border} ${fs.glow}` : ""}`}
          data-testid={`gift-leader-${i + 1}`}
          data-badge-frame={r.sender_badge_frame || ""}
        >
          <span className="text-xs leading-none">{MEDALS[i] || "🏅"}</span>
          {r.sender_avatar_path ? (
            <img src={fileUrl(r.sender_avatar_path)} alt="" className={`w-4 h-4 rounded-full object-cover ${fs ? fs.ring : ""}`} />
          ) : null}
          <span className="text-[10px] font-bold truncate max-w-[80px]">@{r.sender_username}</span>
          {fs && <span className="text-[10px] leading-none">{r.sender_badge_emoji}</span>}
          <span className="text-[9px] font-black tracking-wider">{r.total_waves}W</span>
        </div>
        );
      })}
    </div>
  );
}
